module.exports = __webpack_public_path__ + "search2.png?4425c47bec1fcaea711bc16cd3b3d6dc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/search2.png
// module id = 22
// module chunks = 0